/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
/**
 * ProcurementFileManagementApi - axios parameter creator
 * @export
 */
export const ProcurementFileManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} filePath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementFileManagementControllerDownloadSupplierFile: async (filePath: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filePath' is not null or undefined
            assertParamExists('procurementFileManagementControllerDownloadSupplierFile', 'filePath', filePath)
            const localVarPath = `/procurement-file-management/download-supplier-file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filePath !== undefined) {
                localVarQueryParameter['filePath'] = filePath;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcurementFileManagementApi - functional programming interface
 * @export
 */
export const ProcurementFileManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcurementFileManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} filePath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async procurementFileManagementControllerDownloadSupplierFile(filePath: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.procurementFileManagementControllerDownloadSupplierFile(filePath, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcurementFileManagementApi.procurementFileManagementControllerDownloadSupplierFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProcurementFileManagementApi - factory interface
 * @export
 */
export const ProcurementFileManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcurementFileManagementApiFp(configuration)
    return {
        /**
         * 
         * @param {string} filePath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementFileManagementControllerDownloadSupplierFile(filePath: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.procurementFileManagementControllerDownloadSupplierFile(filePath, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcurementFileManagementApi - object-oriented interface
 * @export
 * @class ProcurementFileManagementApi
 * @extends {BaseAPI}
 */
export class ProcurementFileManagementApi extends BaseAPI {
    /**
     * 
     * @param {string} filePath 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcurementFileManagementApi
     */
    public procurementFileManagementControllerDownloadSupplierFile(filePath: string, options?: RawAxiosRequestConfig) {
        return ProcurementFileManagementApiFp(this.configuration).procurementFileManagementControllerDownloadSupplierFile(filePath, options).then((request) => request(this.axios, this.basePath));
    }
}

